import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { StrapiGatsbyImageType } from "./common";

export enum TileWraperVariants {
  BASIC = "basic",
  IMAGE_RIGHT = "imgRight",
  IMAGE_LEFT = "imgLeft",
  DYNAMIC = "dynamic",
  PIM = "pim",
}
export interface OneTileDynamicZoneModel {
  id: string;
  icon: string;
  title: string;
  subTitle: string;
  color?: string;
}
export interface TileWrapperDynamicZoneModel extends BaseDynamicZoneModel {
  tiles: OneTileDynamicZoneModel[];
  tileWrapperImage?: StrapiGatsbyImageType;
  tileWrapperClassName?: string;
  titleClassName?: string;
  variant: TileWraperVariants;
  bgColor: string;
}
